import { Component, OnInit, OnDestroy } from '@angular/core';
import {
  Router,
  ActivatedRoute,
  NavigationStart,
  NavigationEnd
} from '@angular/router';
import { TdLoadingService } from '@covalent/core';
import { Subscription } from 'rxjs/Subscription';

import { AuthService } from './services/auth.service';
import { MetaTagsService } from './services/meta-tags.service';
import { AdminService } from './services/admin/admin.service';
import { MatDialog } from '@angular/material';
import { Municipality } from './services/Municipality';
import { MunicipalityService } from './services/municipality.service';
import { Location } from '@angular/common';
import { MsdaSideNavService } from './msda-sidenav/service/msda-sidenav.service';
import { environment } from '../environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy {
  municipality: Municipality;
  isAdminRoute: boolean = false;
  isForbiddenRoute: boolean = false;

  currentYear = new Date().getFullYear();

  /**
   * Session data
   */
  sessionData: { [key: string]: any };
  _user: any;
  /**
   * Routes
   */
  routes = [
    {
      link: '/category-list',
      text: 'კატეგორიები'
    },
    {
      link: '/idea-list',
      text: 'იდეები'
    },
    {
      link: '/author-list',
      text: 'ავტორები'
    },
    {
      link: '/instructions',
      text: 'ინსტრუქციები'
    }
  ];

  /**
   * Subscriptions
   */
  private _subs: Set<Subscription> = new Set();
  sidenavOpened: boolean = false;
  /**
   * Constructor
   *
   * @param _router
   * @param _activatedRoute
   * @param _loadingService
   * @param _authService
   * @param _metaTagsService
   */
  constructor(
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private _loadingService: TdLoadingService,
    private _authService: AuthService,
    private _adminService: AdminService,
    private _metaTagsService: MetaTagsService,
    private _matDialog: MatDialog,
    private _municipalityService: MunicipalityService,
    private location: Location,
    private _sidenavService: MsdaSideNavService
  ) {
    const adminUrl = document.location.href.includes('admin');
    const tokenType = adminUrl ? 'private-token' : 'public-token';
    // const token = await this.storage.get(tokenType);

    const queryToken = this._activatedRoute.snapshot.queryParams;
    if (queryToken && queryToken.token && queryToken.token !== 'null') {
      const token = queryToken.token;
      localStorage.setItem(tokenType, String(token));
      this._router.navigate([], {
        queryParams: {
          token: null
        },
        queryParamsHandling: 'merge'
      });
    }
    if (queryToken && queryToken.token === 'null') {
      this._router.navigate([], {
        queryParams: {
          token: null
        },
        queryParamsHandling: 'merge'
      });
    }

    this._setMunicipality();
    this._subs.add(
      this._router.events.subscribe((e) => {
        if (e instanceof NavigationStart) {
          // Close mobile menu
          jQuery(document.body).removeClass('backdrop');
          jQuery('app-root .mat-toolbar .list-unstyled').slideUp(300);
          // Resolve all loaders on NavigationStart
          this._loadingService.resolveAll();
        } else if (e instanceof NavigationEnd) {
          jQuery('html, body')
            .stop()
            .animate({ scrollTop: 0 }, 500, 'swing', () => {});
          // Sidenav configuration
          let route = this._activatedRoute.root;
          this._isAdminRoute(this._router.url);
          this._isForbiddenRoute(this._router.url);
          while (route.firstChild) route = route.firstChild;
          // Get meta tags
          const metaTags =
            route.snapshot.data['metaTags'] || MetaTagsService.defaultMetaTags;
          this._metaTagsService.updateTags(metaTags);
          ga('set', 'page', e.urlAfterRedirects);
          ga('send', 'pageview');
        }
      })
    );
    this._authService.sessionData.subscribe((sessionData) => {
      this.sessionData = sessionData;
      this._adminService.redirectToForbiddenIfNoPermission(
        this.isAdminRoute,
        sessionData
      );
    });

    this._authService.user.subscribe((user) => {
      this._user = user;
    });
  }

  private _isAdminRoute(currentRoute: string): void {
    this.isAdminRoute = currentRoute.includes('admin');
  }
  private _isForbiddenRoute(currentRoute: string) {
    this.isForbiddenRoute = currentRoute.includes('forbidden');
  }
  get token(): string {
    return localStorage.getItem('public-token') || null;
  }
  private _setMunicipality() {
    this._municipalityService.currentMunicipality.subscribe(
      (data) => (this.municipality = data)
    );

    this._router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        if (!this.municipality.clientId) {
          if (this.isAdminRoute) {
            this._municipalityService.changeClient(null, true, '/admin');
          } else {
            this._municipalityService.changeClient();
          }
        }
        (<any>window).ga('set', 'page', event.urlAfterRedirects);
        (<any>window).ga('send', 'pageview');
      }
    });
  }

  changeMunicipality() {
    this._router.navigate(['select-municipality']);
  }

  /**
   * Init
   */
  ngOnInit() {
    // this.disablePinchZoom();
    // FastClick.attach(document.body);
    const sub = this._sidenavService.opened.subscribe((opened) => {
      this.sidenavOpened = opened;
    });
    this._subs.add(sub);
  }

  /**
   * Destroy
   */
  ngOnDestroy() {
    this._subs.forEach((sub) => sub.unsubscribe());
  }
  sidenavOpenedChange(opened: boolean) {
    if (!opened) {
      this._sidenavService.close();
    }
  }

  /**
   *
   */
  disablePinchZoom() {
    delete Hammer.defaults.cssProps.userSelect;

    // the element you want to attach to, probably a wrapper for the page
    const myElement = document.body;
    // create a new hammer object, setting "touchAction" ensures the user can still scroll/pan
    const hammertime = new Hammer(myElement, {
      touchAction: 'pan'
    });

    // pinch is not enabled by default in hammer
    hammertime.get('pinch').set({
      enable: true
    });

    // name the events you want to capture, then call some function if you want and most importantly, add the preventDefault to block the normal pinch action
    hammertime.on('pinch pinchend pinchstart doubletap', (e) => {
      e.preventDefault();
    });
  }

  /**
   * Shows/hides mobile menu
   *
   * @param e
   */
  toggleMobileMenu(e) {
    jQuery(document.body).toggleClass('backdrop');
    jQuery('app-root .mat-toolbar .list-unstyled').slideToggle(300);
  }

  /**
   * Logout
   *
   * @param event
   */
  logout(event: Event) {
    this._loadingService.register();
    this._authService
      .logout()
      .finally(() => {
        this._loadingService.register();
      })
      .subscribe(() => {
        this._router.navigate(['/home']).then(() => location.reload());
      });
  }

  /**
   * Checks if route is active
   *
   * @param route
   */
  isRouteActive(route) {
    const link =
      typeof route === 'string'
        ? route
        : Array.isArray(route.link)
        ? route.link[0]
        : route.link;
    return location.pathname === link;
  }
  get authUrl(): string {
    const isAdmin = this._router.url.includes('admin');
    const urlEndPoint = isAdmin ? 'private' : 'public';

    return `${this.ssourl}/${urlEndPoint}/auth/login?redirectUrl=${document.location.href}`;
  }
  get ssoRegisterUrl(): string {
    return `${this.ssourl}/public/auth/register?redirectUrl=${document.location.href}`;
  }
  get redirectUrlForPasswordChange(): string {
    return document.location.href;
  }
  get currentLocation(): string {
    return document.location.href;
  }
  getClientFlag(clientId: any) {
    return this._municipalityService.municipalityFlag(clientId);
  }
  getClientName(clientId: any) {
    return this._municipalityService.municipalityName(clientId);
  }
  openSidenav() {
    this._sidenavService.open();
  }

  get user() {
    return this._user;
  }

  get isPrivate() {
    return this._user && this._user.userType == 'EMPLOYEE';
  }
  get msUrl(): string {
    return environment.msUrl;
  }
  get ssourl(): string {
    return environment.ssoUrl;
  }
}



// WEBPACK FOOTER //
// /opt/app-root/src/src/app/app.component.ts